module.exports = __webpack_public_path__ + "static/media/event-friends-iphonex-home.74e4248b.jpg";